var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/api/constants.ts
var LocationSource = /* @__PURE__ */ ((LocationSource2) => {
  LocationSource2["Cookies"] = "cookies";
  LocationSource2["Default"] = "default";
  LocationSource2["Ipaddress"] = "ipaddress";
  LocationSource2["Zip5"] = "zip5";
  return LocationSource2;
})(LocationSource || {});
var CookieNames = /* @__PURE__ */ ((CookieNames2) => {
  CookieNames2["City"] = "CVCurrentCity";
  CookieNames2["CVAccessToken"] = "CVAccessToken";
  CookieNames2["CVIdToken"] = "CVIdToken";
  CookieNames2["IpAddress"] = "CVCurrentIpAddress";
  CookieNames2["MerchHasLoggedIn"] = "MerchHasLoggedIn";
  CookieNames2["State"] = "CVCurrentState";
  CookieNames2["Zip"] = "CVCurrentZip";
  return CookieNames2;
})(CookieNames || {});
var DefaultLocation = {
  state: "GA",
  city: "Atlanta",
  zip: "30303",
  ipAddress: ""
};
var TwoWeeks = 1209600;

// src/api/geolocationApi.ts
import jwtDecode from "jwt-decode";

// src/api/lib/LoginCookie.ts
var LoginCookie = class {
  constructor(cookieClient) {
    this.cookieClient = cookieClient;
    this.path = "/";
  }
  get hasAccessTokenCookie() {
    return Boolean(this.cookieClient.get("CVAccessToken" /* CVAccessToken */));
  }
  get hasLoginCookie() {
    return this.cookieClient.get("MerchHasLoggedIn" /* MerchHasLoggedIn */) === "true";
  }
  get shouldSetCookie() {
    return this.hasAccessTokenCookie && !this.hasLoginCookie;
  }
  get shouldRemoveCookie() {
    return this.hasLoginCookie && !this.hasAccessTokenCookie;
  }
  set() {
    this.cookieClient.set("MerchHasLoggedIn" /* MerchHasLoggedIn */, "true", {
      path: this.path
    });
  }
  remove() {
    this.cookieClient.set("MerchHasLoggedIn" /* MerchHasLoggedIn */, "", {
      expires: "Thu, 01 Jan 1970 00:00:00 UTC",
      path: this.path
    });
  }
};

// src/api/lib/cFetch.ts
import fetch from "cross-fetch";
function cFetch(url, options) {
  return __async(this, null, function* () {
    const res = yield fetch(url, options);
    return res.json();
  });
}

// src/api/lib/formatLocationData.ts
function formatLocationData(data) {
  var _a;
  const { city, zip5: zip } = data;
  const state = (_a = data.state) != null ? _a : data.stateAbbreviation;
  if (!city || !state || !zip) {
    throw new Error("Missing required location data");
  }
  return { city, state, zip };
}

// src/api/lib/isValidZipCode.ts
function isValidZipCode(value) {
  return /^\d{5}$/.test(value);
}

// src/api/lib/formatLocationOnError.ts
function formatLocationOnError(cookies) {
  var _a;
  const {
    CVCurrentCity: city,
    CVCurrentState: state,
    CVCurrentZip: zip,
    CVCurrentIpAddress: ipAddress
  } = Object.fromEntries((_a = cookies.getAll()) != null ? _a : []);
  return city && state && isValidZipCode(zip) ? { city, ipAddress, state, zip } : DefaultLocation;
}

// src/api/lib/getLocationFromCookies.ts
var EXPECTED_COOKIE_COUNT = 5;
function getLocationFromCookies(cookies, ipAddress) {
  var _a, _b, _c, _d, _e;
  const location = {
    state: (_a = cookies.get("CVCurrentState" /* State */)) != null ? _a : "",
    city: (_b = cookies.get("CVCurrentCity" /* City */)) != null ? _b : "",
    zip: (_c = cookies.get("CVCurrentZip" /* Zip */)) != null ? _c : "",
    ipAddress: (_e = (_d = cookies.get("CVCurrentIpAddress" /* IpAddress */)) != null ? _d : ipAddress) != null ? _e : "",
    source: "cookies" /* Cookies */
  };
  const receivedCookieCount = Object.values(location).filter(Boolean).length;
  return receivedCookieCount === EXPECTED_COOKIE_COUNT ? location : null;
}

// src/api/lib/isServerSide.ts
var isServerSide = function serverSideCheck() {
  try {
    return typeof window === "undefined";
  } catch (e) {
    return true;
  }
}();
var isServerSide_default = isServerSide;

// src/api/lib/capitalize.ts
function capitalize(str) {
  const firstLetter = str.charAt(0).toUpperCase();
  const restOfKey = str.slice(1);
  return `${firstLetter}${restOfKey}`;
}

// src/api/lib/setCookies.ts
function setCookies(client, cookies, options = {}) {
  const setCookie = ([key, value]) => {
    if (value)
      client.set(`CVCurrent${capitalize(key)}`, value, options);
  };
  Object.entries(cookies).forEach(setCookie);
}

// src/api/lib/toError.ts
function toError(err) {
  return err instanceof Error ? err : new Error(String(err));
}

// src/api/geolocationApi.ts
var GeoLocationApi = class {
  constructor(cookies, internalConfig, fetcher = cFetch, fetcherWithAuth = fetcher) {
    this.cookies = cookies;
    this.internalConfig = internalConfig;
    this.fetcher = fetcher;
    this.fetcherWithAuth = fetcherWithAuth;
    this.loginCookie = new LoginCookie(cookies);
  }
  getGeoLocation() {
    return __async(this, null, function* () {
      var _a, _b;
      const location = (_b = (_a = yield this.maybeGetAccountLocation()) != null ? _a : this.getLocationFromCookies()) != null ? _b : yield this.getGeoLocationFromIpAddress();
      this.setLocationCookies(location);
      return location;
    });
  }
  setGeoLocation(zip) {
    return __async(this, null, function* () {
      var _a;
      const location = (_a = yield this.maybeGetAccountLocation()) != null ? _a : yield this.setGeoLocationWithZip(zip);
      this.setLocationCookies(location);
      return location;
    });
  }
  getAccountLocation() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      try {
        const CVAccessToken = this.cookies.get("CVAccessToken" /* CVAccessToken */);
        const CVIdToken = this.cookies.get("CVIdToken" /* CVIdToken */);
        if (!CVAccessToken || !CVIdToken)
          return "";
        const userInfo = jwtDecode(CVIdToken);
        const userProfile = yield this.fetcherWithAuth(
          `${this.internalConfig.contactsApi}/${userInfo.user_id}/addresses`
        );
        const zipCodes = (_a = userProfile == null ? void 0 : userProfile.content) == null ? void 0 : _a.reduce(
          (zipcodes, address) => {
            var _a2, _b2;
            const kind = address == null ? void 0 : address.kind;
            const zip5 = (_b2 = (_a2 = address == null ? void 0 : address.address) == null ? void 0 : _a2.zipCode) == null ? void 0 : _b2.zip5;
            return __spreadProps(__spreadValues({}, zipcodes), { [kind]: zip5 });
          },
          {}
        );
        return (_d = (_c = (_b = zipCodes == null ? void 0 : zipCodes.DeliveryZip) != null ? _b : zipCodes == null ? void 0 : zipCodes.VerifiedDelivery) != null ? _c : zipCodes == null ? void 0 : zipCodes.VerifiedHome) != null ? _d : "";
      } catch (e) {
        return "";
      }
    });
  }
  maybeGetAccountLocation() {
    return __async(this, null, function* () {
      if (this.loginCookie.shouldRemoveCookie) {
        this.loginCookie.remove();
        return void 0;
      }
      if (!this.loginCookie.shouldSetCookie) {
        return void 0;
      }
      const zip = yield this.getAccountLocation();
      if (zip && !isServerSide_default) {
        this.loginCookie.set();
      }
      return zip ? this.setGeoLocationWithZip(zip) : void 0;
    });
  }
  getLocationFromCookies() {
    var _a;
    const location = getLocationFromCookies(
      this.cookies,
      this.internalConfig.ipAddress
    );
    if (!isValidZipCode((_a = location == null ? void 0 : location.zip) != null ? _a : "")) {
      return null;
    }
    if (location == null ? void 0 : location.ipAddress) {
      this.cookies.set("CVCurrentIpAddress", location.ipAddress, { path: "/" });
    }
    return location;
  }
  getGeoLocationFromIpAddress() {
    return __async(this, null, function* () {
      var _a;
      const url = new URL(this.internalConfig.geolocationApi);
      url.searchParams.set("ipaddress", (_a = this.internalConfig.ipAddress) != null ? _a : "");
      return this.getGeoLocationFromApi(url.toString(), "ipaddress" /* Ipaddress */);
    });
  }
  setGeoLocationWithZip(zip) {
    return __async(this, null, function* () {
      const url = new URL(this.internalConfig.contextApi);
      url.searchParams.set("zip5", zip);
      return this.getGeoLocationFromApi(url.toString(), "zip5" /* Zip5 */);
    });
  }
  getGeoLocationFromApi(url, source) {
    return __async(this, null, function* () {
      var _a;
      try {
        const fetchedLocation = yield this.fetcher(url.toString());
        return __spreadProps(__spreadValues({}, formatLocationData(fetchedLocation)), {
          ipAddress: (_a = this.internalConfig.ipAddress) != null ? _a : "",
          source
        });
      } catch (err) {
        const location = formatLocationOnError(this.cookies);
        if (this.internalConfig.onError) {
          this.internalConfig.onError(toError(err));
        }
        return __spreadProps(__spreadValues({}, location), {
          ipAddress: location.ipAddress || this.internalConfig.ipAddress || "",
          source: "default" /* Default */
        });
      }
    });
  }
  setLocationCookies(_a) {
    var _b = _a, {
      source: _source
    } = _b, locationWithoutSource = __objRest(_b, [
      "source"
    ]);
    setCookies(this.cookies, locationWithoutSource, {
      path: "/",
      "Max-Age": TwoWeeks
    });
  }
  updateAccountDeliveryInfo(_0) {
    return __async(this, arguments, function* ({
      CVIdToken,
      zip
    }) {
      try {
        const userInfo = jwtDecode(CVIdToken);
        if (userInfo.is_impersonating === "False")
          yield this.fetcherWithAuth(
            `${this.internalConfig.contactsApi}/${userInfo.user_id}/addresses/delivery-zip5`,
            {
              body: JSON.stringify({
                contactId: userInfo.user_id,
                actorId: userInfo.impersonating_user,
                zip5: zip
              }),
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST"
            }
          );
      } catch (err) {
        if (this.internalConfig.onError) {
          this.internalConfig.onError(toError(err));
        }
      }
    });
  }
};

// src/api/http/axios.ts
function wrap(axios) {
  return (url, options) => {
    const requestConfig = __spreadProps(__spreadValues({}, options), {
      data: options == null ? void 0 : options.body
    });
    return axios(url, requestConfig).then((res) => res.data);
  };
}

// src/api/http/got.ts
function wrap2(got) {
  return (url, options) => {
    const requestConfig = __spreadProps(__spreadValues({}, options), {
      method: options == null ? void 0 : options.method
    });
    return got(url, requestConfig).json();
  };
}

// src/api/lib/generalizedCookieClient.ts
function generateCookieMap(cookieString) {
  return new Map(
    cookieString.split(/; ?/).map((cookie) => {
      const [key, value] = cookie.trim().split("=");
      return [key, decodeURI(value)];
    })
  );
}
var ServerCookies = class {
  constructor(request) {
    this.request = request;
  }
  getCookie() {
    const cookie = this.request.headers.cookie;
    if (!cookie) {
      throw new Error("Cookie header not found");
    }
    return cookie;
  }
};
var ExpressCookieAdapter = class extends ServerCookies {
  constructor(request, httpResponse) {
    super(request);
    this.httpResponse = httpResponse;
  }
  get cookie() {
    return this.getCookie();
  }
  set cookie(cookie) {
    this.httpResponse.append("Set-Cookie", cookie);
  }
};
var NodeCookieAdapter = class extends ServerCookies {
  constructor(request, httpResponse) {
    super(request);
    this.httpResponse = httpResponse;
  }
  get cookie() {
    return this.getCookie();
  }
  set cookie(cookie) {
    this.httpResponse.setHeader("Set-Cookie", cookie);
  }
};
var ClientCookieAdapter = class {
  constructor(document) {
    this.document = document;
  }
  get cookie() {
    return this.document.cookie;
  }
  set cookie(cookie) {
    this.document.cookie = cookie;
  }
};
var GeneralizedCookieClient = class {
  constructor(client) {
    this.client = client;
  }
  get(name) {
    var _a;
    const cookie = (_a = this.client.cookie.split(/; ?/gim).find((pairing) => pairing.startsWith(name))) != null ? _a : "";
    const [, value] = cookie.split("=");
    return value ? decodeURI(value) : void 0;
  }
  getAll() {
    return generateCookieMap(this.client.cookie);
  }
  set(name, value, options = {}) {
    const cookieItems = [`${name}=${decodeURI(value)}`];
    Object.entries(options).forEach(
      ([optionName, optionVal]) => cookieItems.push(`${capitalize(optionName)}=${optionVal}`)
    );
    this.client.cookie = cookieItems.join("; ").trim();
  }
};

// src/banner/index.tsx
import React2 from "react";

// src/banner/icons/ErrorFilled.tsx
import React from "react";
function ErrorFilled() {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    fill: "#EB9F23"
  }));
}

// src/banner/index.tsx
function DeliveryBanner(props) {
  const { zip, openCallback } = props;
  return /* @__PURE__ */ React2.createElement("div", {
    "data-package": "geolocation",
    "data-testid": "delivery-banner"
  }, /* @__PURE__ */ React2.createElement("div", {
    className: "py-[14px] md:py-[18px] flex justify-center align-center bg-grey-1 max-w-full text-base"
  }, /* @__PURE__ */ React2.createElement(ErrorFilled, null), /* @__PURE__ */ React2.createElement("div", {
    className: "t-header-xs md:t-header-s font-sans text-blue-6 px-8"
  }, "Delivery unavailable for ", zip), /* @__PURE__ */ React2.createElement("div", {
    className: "cursor-pointer t-header-xs md:t-header-s font-sans text-blue-2 hover:text-blue-3",
    tabIndex: 0,
    onClick: () => {
      openCallback(true);
    },
    onKeyUp: (e) => e.key === "Enter" && openCallback(true)
  }, "Change Location")));
}

// src/modal/Modal.tsx
import React18 from "react";

// src/modal/components/DeliverableContent.tsx
import React15 from "react";

// src/modal/components/AcquisitionOptions/AcquisitionOptions.tsx
import React4 from "react";

// src/modal/context/LocationContext.tsx
import React3, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";

// src/modal/lib/hasValidLocation.ts
function hasValidLocation({ city, state, zip }) {
  const foundLocation = [city, state, zip].filter(Boolean);
  return Boolean(foundLocation.length === 3);
}

// src/modal/lib/maybeIsExcludedLocation.ts
function maybeIsExcludedLocation({ isMeetupAllowed, isDeliveryAllowed, pickUpInfoToDisplay }) {
  return Boolean(!isDeliveryAllowed && !isMeetupAllowed && !pickUpInfoToDisplay);
}

// src/modal/context/LocationContext.tsx
var defaultErrorState = {
  deliveryError: false,
  locationError: false
};
var defaultState = {
  city: "",
  state: "",
  zip: ""
};
var defaultContext = __spreadProps(__spreadValues({}, defaultState), {
  errorState: defaultErrorState,
  isExcludedLocation: false,
  onCloseHandler: () => {
  },
  setGeolocation: (_zipcode) => new Promise(
    (resolve) => resolve({
      city: "",
      source: void 0,
      state: "",
      zip: ""
    })
  )
});
var LocationContext = createContext(defaultContext);
var useLocationContext = () => useContext(LocationContext);
function LocationProvider({
  children,
  geoApi,
  onCloseHandler,
  fetchDelivery,
  onUserLocationChange
}) {
  const [location, setLocation] = useState(defaultState);
  const [errorState, setErrorState] = useState(defaultErrorState);
  const setGeolocation = useCallback(
    (zipcode) => __async(this, null, function* () {
      const templocation = {
        city: "",
        state: "",
        zip: ""
      };
      const errors = {
        locationError: false,
        deliveryError: false
      };
      try {
        const res = yield geoApi.setGeoLocation(zipcode);
        if (res.zip) {
          templocation.city = res.city;
          templocation.state = res.state;
          templocation.zip = res.zip;
        } else {
          errors.locationError = true;
        }
      } catch (err) {
        errors.locationError = true;
      }
      try {
        if (!errors.locationError) {
          const { pickUpInfoToDisplay, isMeetupAllowed, isDeliveryAllowed } = yield fetchDelivery(zipcode);
          templocation.pickUpInfoToDisplay = pickUpInfoToDisplay;
          templocation.isMeetupAllowed = isMeetupAllowed;
          templocation.isDeliveryAllowed = isDeliveryAllowed;
        }
      } catch (err) {
        errors.deliveryError = true;
      }
      if (onUserLocationChange) {
        onUserLocationChange({
          location: templocation,
          errorState: errors
        });
      }
      setErrorState(errors);
      if (hasValidLocation(templocation))
        setLocation(templocation);
      return templocation;
    }),
    [geoApi, fetchDelivery, onUserLocationChange]
  );
  useEffect(() => {
    (() => __async(this, null, function* () {
      const templocation = {
        city: "",
        state: "",
        zip: ""
      };
      const errors = {
        locationError: false,
        deliveryError: false
      };
      try {
        const res = yield geoApi.getGeoLocation();
        templocation.city = res.city;
        templocation.state = res.state;
        templocation.zip = res.zip;
      } catch (err) {
        errors.locationError = true;
      }
      try {
        if (!errors.locationError) {
          const { pickUpInfoToDisplay, isMeetupAllowed, isDeliveryAllowed } = yield fetchDelivery(templocation.zip);
          templocation.pickUpInfoToDisplay = pickUpInfoToDisplay;
          templocation.isMeetupAllowed = isMeetupAllowed;
          templocation.isDeliveryAllowed = isDeliveryAllowed;
        }
      } catch (err) {
        errors.deliveryError = true;
      }
      if (onUserLocationChange) {
        onUserLocationChange({
          location: templocation,
          errorState: errors
        });
      }
      setErrorState(errors);
      setLocation(templocation);
    }))();
  }, [fetchDelivery, geoApi, onUserLocationChange]);
  const isExcludedLocation = maybeIsExcludedLocation(location);
  const value = useMemo(
    () => __spreadProps(__spreadValues({}, location), {
      errorState,
      isExcludedLocation,
      onCloseHandler,
      setGeolocation
    }),
    [errorState, isExcludedLocation, location, onCloseHandler, setGeolocation]
  );
  return /* @__PURE__ */ React3.createElement(LocationContext.Provider, {
    value
  }, children);
}

// src/modal/components/AcquisitionOptions/AcquisitionOptions.tsx
function AcquisitionOptions({ children }) {
  const { errorState, zip, isExcludedLocation } = useLocationContext();
  if (!zip && errorState.locationError || isExcludedLocation)
    return null;
  return /* @__PURE__ */ React4.createElement("div", {
    "data-testid": "acquisition-options",
    className: "flex s:flex-col m:flex-row w-full m:py-32 s:max-m:pb-48 justify-evenly"
  }, children);
}

// src/modal/components/AcquisitionOptions/DeliveryOption.tsx
import React6 from "react";

// src/modal/components/AcquisitionOptions/AcquisitionOption.tsx
import React5 from "react";
function AcquistionOption({
  title,
  text,
  conditionalClasses
}) {
  return /* @__PURE__ */ React5.createElement("div", {
    "data-testid": `${title.toLowerCase().split(" ").join("-")}-option`,
    className: `text-center m:px-20 m:w-1/2 s:w-full s:max-m:before:bg-grey-2 before:content-[''] s:max-m:before:h-[1px] s:max-m:before:absolute s:max-m:before:top-0 s:max-m:before:left-0 s:max-m:before:right-0 s:max-m:before:m-auto s:max-m:before:w-[100px] s:max-m:relative s:max-m:pt-32 s:max-m:first:pb-32 s:max-s:whitespace-nowrap ${conditionalClasses}`
  }, /* @__PURE__ */ React5.createElement("p", {
    className: "m-0 t-header-m text-blue-6 uppercase"
  }, title), /* @__PURE__ */ React5.createElement("p", {
    className: "m-0 mt-8 t-body-s text-grey-5"
  }, text));
}

// src/modal/components/AcquisitionOptions/DeliveryOption.tsx
function DeliveryOption() {
  const { isDeliveryAllowed = true } = useLocationContext();
  return isDeliveryAllowed ? /* @__PURE__ */ React6.createElement(AcquistionOption, {
    title: "delivery",
    text: "Yay! Delivery is available in your location."
  }) : null;
}

// src/modal/components/AcquisitionOptions/PickupOption.tsx
import React7 from "react";
function PickUpOption() {
  const {
    pickUpInfoToDisplay,
    isDeliveryAllowed = true,
    isMeetupAllowed = false
  } = useLocationContext();
  const { pickupLocation, milesToPickupLocation } = pickUpInfoToDisplay != null ? pickUpInfoToDisplay : {};
  const pickupInfo = ` ${pickupLocation == null ? void 0 : pickupLocation.city}, ${pickupLocation == null ? void 0 : pickupLocation.state} (${milesToPickupLocation} miles away)`;
  const dividerClasses = isDeliveryAllowed || isMeetupAllowed ? "m:first:border-0 m:first:border-r m:first:border-grey-2 m:first:border-solid" : "";
  return /* @__PURE__ */ React7.createElement(AcquistionOption, {
    conditionalClasses: dividerClasses,
    title: "pick up",
    text: `The nearest pickup location is ${pickupInfo}.`
  });
}

// src/modal/components/Cta.tsx
import cx from "classnames";
import React8 from "react";
function ModalCta({ ctaText }) {
  const { isDeliveryAllowed = true } = useLocationContext();
  return /* @__PURE__ */ React8.createElement("div", {
    "data-testid": "delivery-text",
    className: cx("pt-32 s:max-m:px-24 t-header-m text-blue-6 text-center", {
      "bg-grey-1 pb-0": isDeliveryAllowed,
      "pb-32": !isDeliveryAllowed
    })
  }, ctaText);
}

// src/modal/components/LocationDisplay/CityStateInfo.tsx
import cx2 from "classnames";
import React10 from "react";

// src/modal/components/LocationDisplay/Location.tsx
import React9 from "react";
function Location() {
  const { city, state } = useLocationContext();
  return /* @__PURE__ */ React9.createElement("p", {
    "data-testid": "location",
    className: "m-0 flex justify-center align-middle mt-[6px] t-header-s text-blue-6 text-center"
  }, /* @__PURE__ */ React9.createElement("svg", {
    className: "mr-8",
    width: "14",
    height: "19",
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React9.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99943 0.946777C10.5081 0.946777 13.3524 3.79109 13.3524 7.29972C13.3524 12 7.7406 18.5127 7.7406 18.5127C7.57191 18.762 7.29943 18.9216 6.99943 18.9468C6.70731 18.9211 6.43893 18.7754 6.25825 18.5444C6.25825 18.5444 0.646484 12 0.646484 7.29972C0.686527 3.80781 3.50751 0.98682 6.99943 0.946777ZM9.37115 7.16188C9.38277 5.83866 8.32263 4.75494 6.99947 4.73745C5.66445 4.73157 4.57583 5.80599 4.56418 7.14098C4.5643 8.46425 5.634 9.53852 6.95726 9.54428C8.28052 9.55003 9.35953 8.4851 9.37115 7.16188Z",
    fill: "#122946"
  })), /* @__PURE__ */ React9.createElement("span", null, city, ", ", state));
}

// src/modal/components/LocationDisplay/CityStateInfo.tsx
function CityStateInfo() {
  const {
    errorState,
    city,
    isDeliveryAllowed = true,
    isExcludedLocation
  } = useLocationContext();
  if (!city && errorState.locationError || isExcludedLocation)
    return null;
  return /* @__PURE__ */ React10.createElement("div", {
    "data-testid": "city-state-info",
    className: cx2(
      "m:pb-[26px] m:p-24 s:max-m:pb-32 text-center w-11/12 m:border-0 m:border-solid m:border-b m:border-grey-2",
      {
        "m:pb-4": !isDeliveryAllowed,
        "m:border-b-0": !isDeliveryAllowed,
        "m:border-t": !isDeliveryAllowed
      }
    )
  }, /* @__PURE__ */ React10.createElement("p", {
    className: "m-0 t-body-s text-grey-5"
  }, "Options for getting your vehicle in:"), /* @__PURE__ */ React10.createElement(Location, null));
}

// src/modal/components/LocationDisplay/LocationDisplay.tsx
import cx3 from "classnames";
import React11 from "react";
function LocationDisplay({ children }) {
  const { isDeliveryAllowed = true } = useLocationContext();
  return /* @__PURE__ */ React11.createElement("div", {
    "data-testid": "availability-info",
    className: cx3(
      "flex flex-col items-center m:justify-center s:max-m:px-24",
      {
        "bg-white": isDeliveryAllowed,
        "s:max-m:h-screen": isDeliveryAllowed,
        "s:max-m:pt-32": isDeliveryAllowed
      }
    )
  }, children);
}

// src/modal/components/LocationInputForm/FormWrapper.tsx
import cx4 from "classnames";
import React14 from "react";

// src/modal/components/LocationInputForm/Form.tsx
import React12, { useState as useState2, useEffect as useEffect2 } from "react";

// src/modal/components/LocationInputForm/getSubmissionCallback.ts
function getSubmissionCallback(fn, value) {
  return ({ zip: currentZip }) => {
    if (!currentZip)
      fn(value);
  };
}

// src/modal/components/LocationInputForm/handleSelectOnFocus.ts
function handleSelectOnFocus(e) {
  e.target.select();
}

// src/modal/components/LocationInputForm/handleSubmit.ts
function handleSubmit(fn, value, onSubmitCallback, closeHandler) {
  return (e) => {
    e.preventDefault();
    fn(value).then(onSubmitCallback).then(closeHandler);
  };
}

// src/modal/components/LocationInputForm/Form.tsx
var LABEL = "zip code";
function Form() {
  const { zip, setGeolocation, onCloseHandler } = useLocationContext();
  const [inputValue, setInputValue] = useState2(() => zip);
  useEffect2(() => {
    setInputValue(zip);
  }, [zip]);
  return /* @__PURE__ */ React12.createElement("form", {
    "data-testid": "zipcode-form",
    onSubmit: handleSubmit(
      setGeolocation,
      inputValue,
      getSubmissionCallback(setInputValue, zip),
      onCloseHandler
    ),
    className: "flex mt-24 align-top"
  }, /* @__PURE__ */ React12.createElement("fieldset", {
    className: "relative outline-none focus-within:border-blue-6 bg-white border-solid border-grey-2 border rounded w-[129px] mr-8 p-0"
  }, /* @__PURE__ */ React12.createElement("input", {
    "data-testid": "zipcode-form-input",
    id: LABEL,
    maxLength: 5,
    name: "zipcode",
    onBlur: () => {
      if (inputValue === zip || !inputValue) {
        setInputValue(zip);
      }
    },
    onFocus: handleSelectOnFocus,
    onChange: (e) => {
      setInputValue(e.target.value);
    },
    value: inputValue,
    type: "text",
    title: "Please enter a valid zip code.",
    placeholder: "Zip Code",
    pattern: "[0-9]{5}",
    className: "peer outline-none left-0 border-none min-w-0 relative pt-[22px] pb-[7px] px-0 block box-border mt-17 leading-19 overflow-visible text-base indent-16 w-full h-19 absolute t-body-m focus:!text-blue-6 placeholder-transparent placholder:text-grey-3 bg-transparent"
  }), /* @__PURE__ */ React12.createElement("label", {
    "data-testid": "zipcode-form-label",
    htmlFor: LABEL,
    className: "text-[13px] font-bold block p-0 absolute top-[2px] uppercase peer-placeholder-shown:translate-y-[19px] peer-placeholder-shown:scale-100 origin-top-left transition duration-200 ease-out delay-[0] mb-[8px] leading-[13px] scale-[0.63] translate-x-0 peer-placeholder-shown:translate-x-0 translate-y-[11px] text-blue-2 transform peer-placeholder-shown:text-grey-2 left-16 peer-focus:translate-y-[11px] peer-focus:scale-[0.63] peer-focus:translate-x-0 peer-focus:text-blue-2 z-0"
  }, LABEL)), /* @__PURE__ */ React12.createElement("button", {
    "data-analytics-id": "Geolocation - Changed Zip",
    type: "submit",
    className: "uppercase leading-none h-56 w-[100px] text-white rounded font-bold border-0 disabled:text-grey-5 bg-blue-2 hover:bg-blue-3",
    "data-testid": "zipcode-form-submit"
  }, "UPDATE"));
}

// src/modal/components/LocationDisplay/LocationWrapper.tsx
import React13 from "react";
function LocationWrapper({ children }) {
  const { isExcludedLocation } = useLocationContext();
  return isExcludedLocation ? /* @__PURE__ */ React13.createElement("div", {
    "data-testid": "location-wrapper",
    className: "pt-24"
  }, children) : null;
}

// src/modal/components/LocationInputForm/FormWrapper.tsx
function LocationInputForm({ formHeading }) {
  const { isDeliveryAllowed = true } = useLocationContext();
  return /* @__PURE__ */ React14.createElement("div", {
    "data-testid": "form-wrapper",
    className: cx4(
      "bg-grey-1 px-24 pb-32 flex flex-col items-center border-0 border-solid border-b border-grey-2",
      {
        "pt-32": !isDeliveryAllowed,
        "pb-48": !isDeliveryAllowed,
        "s:max-m:h-full": !isDeliveryAllowed
      }
    )
  }, /* @__PURE__ */ React14.createElement("p", {
    "data-testid": "form-heading",
    className: cx4("m-0 pt-8 text-center t-body-m text-grey-5", {
      "w-[257px]": !isDeliveryAllowed
    })
  }, formHeading), /* @__PURE__ */ React14.createElement(Form, null), /* @__PURE__ */ React14.createElement(LocationWrapper, null, /* @__PURE__ */ React14.createElement(Location, null)));
}

// src/modal/lib/getFormHeading.ts
var headingMap = /* @__PURE__ */ new Map([
  ["hasErrored", "Unable to set your location, please try again."],
  [
    "isExcludedLocation",
    "Please update your ZIP code to purchase from a different location"
  ],
  [
    "isDeliveryAllowed",
    "We'll show you the most accurate shipping cost and delivery estimates based on your location."
  ]
]);
var getFirstTruthyOption = (options) => {
  var _a;
  const [firstTruthyOption = ""] = (_a = Object.entries(options).find(([, val]) => val)) != null ? _a : [];
  return firstTruthyOption;
};
function getFormHeading({
  hasErrored,
  isExcludedLocation,
  isDeliveryAllowed
}) {
  const headingOption = getFirstTruthyOption({
    hasErrored,
    isExcludedLocation,
    isDeliveryAllowed
  });
  const formHeading = headingMap.get(headingOption);
  return formHeading != null ? formHeading : "Or you can update your ZIP code to purchase from a different location.";
}

// src/modal/lib/maybeErrored.ts
function getHasErrored({
  locationError,
  deliveryError
}) {
  return Boolean(locationError || deliveryError);
}

// src/modal/components/DeliverableContent.tsx
function DeliverableContent() {
  const { isDeliveryAllowed = true, errorState, isExcludedLocation } = useLocationContext();
  const hasErrored = getHasErrored(errorState);
  const formHeading = getFormHeading({ hasErrored, isExcludedLocation, isDeliveryAllowed });
  return isDeliveryAllowed ? /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(ModalCta, {
    ctaText: "Enter Your ZIP Code"
  }), /* @__PURE__ */ React15.createElement(LocationInputForm, {
    formHeading
  }), /* @__PURE__ */ React15.createElement(LocationDisplay, null, /* @__PURE__ */ React15.createElement(CityStateInfo, null), /* @__PURE__ */ React15.createElement(AcquisitionOptions, null, /* @__PURE__ */ React15.createElement(PickUpOption, null), /* @__PURE__ */ React15.createElement(DeliveryOption, null)))) : null;
}

// src/modal/components/UndeliverableContent.tsx
import React17 from "react";

// src/modal/components/AcquisitionOptions/MeetupOption.tsx
import React16 from "react";
function MeetUpOption() {
  const { isMeetupAllowed = false } = useLocationContext();
  return isMeetupAllowed ? /* @__PURE__ */ React16.createElement(AcquistionOption, {
    title: "meet up",
    text: "Meet us somewhere in the middle."
  }) : null;
}

// src/modal/components/UndeliverableContent.tsx
function UndeliverableContent() {
  const { isDeliveryAllowed = true, errorState, isExcludedLocation } = useLocationContext();
  const hasErrored = getHasErrored(errorState);
  const formHeading = getFormHeading({ hasErrored, isExcludedLocation, isDeliveryAllowed });
  const ctaText = isExcludedLocation ? "Delivery Is Unavailable In Your Area" : "Delivery Is Unavailable, But You Still Have Options";
  return !isDeliveryAllowed ? /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(ModalCta, {
    ctaText
  }), /* @__PURE__ */ React17.createElement(LocationDisplay, null, /* @__PURE__ */ React17.createElement(CityStateInfo, null), /* @__PURE__ */ React17.createElement(AcquisitionOptions, null, /* @__PURE__ */ React17.createElement(PickUpOption, null), /* @__PURE__ */ React17.createElement(MeetUpOption, null))), /* @__PURE__ */ React17.createElement(LocationInputForm, {
    formHeading
  })) : null;
}

// src/modal/Modal.tsx
function ModalContents() {
  return /* @__PURE__ */ React18.createElement("div", {
    "data-package": "geolocation",
    "data-testid": "geolocation-modal"
  }, /* @__PURE__ */ React18.createElement("div", {
    className: "bg-white"
  }, /* @__PURE__ */ React18.createElement(DeliverableContent, null), /* @__PURE__ */ React18.createElement(UndeliverableContent, null)));
}
function Modal({ children, config }) {
  return /* @__PURE__ */ React18.createElement(LocationProvider, __spreadValues({}, config), children ? children({ content: /* @__PURE__ */ React18.createElement(ModalContents, null) }) : /* @__PURE__ */ React18.createElement(ModalContents, null));
}
export {
  ClientCookieAdapter,
  CookieNames,
  DefaultLocation,
  DeliveryBanner,
  ExpressCookieAdapter,
  GeneralizedCookieClient,
  GeoLocationApi,
  Modal as GeoModal,
  LocationSource,
  NodeCookieAdapter,
  generateCookieMap,
  wrap as wrapAxios,
  wrap2 as wrapGot
};
//# sourceMappingURL=index.js.map
